import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { LoanMetric } from '../../types/dashboard';
interface MetricCardProps {
  metric: LoanMetric;
}
export function MetricCard({
  metric
}: MetricCardProps) {
  const isPositive = metric.trendDirection === 'up';
  const isNeutral = metric.trendDirection === 'neutral';
  // For some metrics (like turn time), down is good.
  // We'll use the 'status' field to determine color.
  const statusColor = metric.status === 'good' ? 'text-emerald-500' : metric.status === 'warning' ? 'text-amber-500' : 'text-rose-500';
  const trendColor = metric.status === 'good' ? 'text-emerald-600 bg-emerald-50' : metric.status === 'warning' ? 'text-amber-600 bg-amber-50' : 'text-rose-600 bg-rose-50';
  return <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-103">
      <div className="flex justify-between items-start mb-4" data-id="element-104">
        <h3 className="text-slate-500 text-sm font-medium uppercase tracking-wider" data-id="element-105">
          {metric.label}
        </h3>
        <div className={`flex items-center px-2 py-1 rounded-full text-xs font-semibold ${trendColor}`} data-id="element-106">
          {metric.trendDirection === 'up' && <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-107" />}
          {metric.trendDirection === 'down' && <ArrowDownRight className="w-3 h-3 mr-1" data-id="element-108" />}
          {metric.trendDirection === 'neutral' && <Minus className="w-3 h-3 mr-1" data-id="element-109" />}
          {Math.abs(metric.trend)}%
        </div>
      </div>
      <div className="flex items-baseline" data-id="element-110">
        <span className="text-3xl font-bold text-slate-900" data-id="element-111">
          {metric.value}
        </span>
      </div>
      <div className="mt-2 text-xs text-slate-400" data-id="element-112">vs. previous 30 days</div>
    </div>;
}